var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_622_2430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2C24.8219 2 31.9999 8.27998 31.9999 15.9999C31.9999 19.1639 30.7919 22.1999 28.5739 24.6399L31.7579 28.3479C32.0139 28.6439 32.0719 29.0619 31.9079 29.4159C31.7459 29.7719 31.3899 29.9999 30.9999 29.9999H16C7.17798 29.9999 9.53674e-06 23.7199 9.53674e-06 15.9999C9.53674e-06 8.27998 7.17798 2 16 2Z",
    fill: "url(#paint0_linear_622_2430)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 18C14.8953 18 13.9999 17.1046 13.9999 16C13.9999 14.8954 14.8953 14 15.9999 14C17.1045 14 17.9999 14.8954 17.9999 16C17.9999 17.1046 17.1045 18 15.9999 18Z",
    fill: "#603CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 18C22.8953 18 21.9999 17.1046 21.9999 16C21.9999 14.8954 22.8953 14 23.9999 14C25.1045 14 25.9999 14.8954 25.9999 16C25.9999 17.1046 25.1045 18 23.9999 18Z",
    fill: "#603CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 18C6.89544 18 6.00002 17.1046 6.00002 16C6.00002 14.8954 6.89544 14 8.00001 14C9.10457 14 10 14.8954 10 16C10 17.1046 9.10457 18 8.00001 18Z",
    fill: "#603CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_622_2430",
    x1: 9,
    y1: 5,
    x2: 19.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8585EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_622_2430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 32 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAiIcon);
export default __webpack_public_path__ + "static/media/chat_AI_icon.33bab869b1bc61128f6ae3d405bec23a.svg";
export { ForwardRef as ReactComponent };